export const TimeOutActionType = {
	SET_TIMEOUT: "SET_TIMEOUT",
};
